import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { Check, Lens, Remove, Search } from '@material-ui/icons';
import SpinnerComponent from '../../../components/SpinnerComponent';
import EditRecordButton from '../components/EditRecordButton';
import NewRecordButton from '../components/NewRecordButton';
import BasicTable from '../../../components/BasicTable.js';
import SelezioneGruppo from '../components/SelezioneGruppo';
import TablePageToolbar from '../components/TablePageToolbar';
import ModalResponsabiliEsercizio from '../components/ModalResponsabiliEsercizio';
import {
  getCountEserciziCommerciali,
  getEserciziCommerciali,
  getEserciziCommercialiFiltered,
} from '../../../utils/api/esercizi_commerciali_api';
import { getResponsabiliSicurezzaEsercizio } from '../../../utils/api/responsabili_sicurezza_api';
import { getGruppi } from '../../../utils/api/gruppi_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = {
  mainContainer: {
    textAlign: 'center',
    color: 'black',
  },
  newRecordButtonWrapper: {
    paddingTop: '10px',
    paddingBottom: '10px',
    textAlign: 'right',
  },
};

export default class EserciziCommercialiTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      esercizi: [],
      gruppoId: null,
      gruppi: [],
      gruppoInfo: null,
      loading: true,
      isModalResponsabiliOpen: false,
      selectedEsercizioName: '',
      responsabiliEsercizio: [],
      loadingModalResponsabili: false,
      errorModalResponsabili: '',
      totalPages: 1,
      loadedPage: 0,
      pageSize: 10,
      filter: {
        esercizioId: '',
        gruppoId: '',
        consulenteId: '',
        ragioneSociale: '',
        partitaIva: '',
        nome: '',
        cittaSede: '',
      },
    };
  }

  componentDidMount() {
    if (this.props.consulenteId === null) {
      //User is Admin
      this.fetchGruppi();
    } else {
      let id = this.props.gruppoId;
      this.setState({
        gruppoId: id,
      });
      this.fetchEserciziCommerciali(id);
    }
  }

  fetchGruppi = () => {
    getGruppi(null, null, 0, 1000, 'nome')
      .then((result) => {
        let newarray = [{ id: -1, nome: 'Tutti i gruppi' }];
        newarray.push(...result);
        let gruppoId = this.state.gruppoId;
        if (gruppoId === null) {
          gruppoId = -1;
        }
        this.setState({
          gruppi: newarray,
          gruppoId,
        });
        this.fetchEserciziCommerciali(gruppoId);
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  fetchEserciziCommerciali = (gruppoId) => {
    const isAdmin = this.props.consulenteId === null;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;

    const consulenteId = isConsulente ? this.props.consulenteId : null;

    if (!isAdmin) {
      gruppoId = this.props.gruppoId;
    }

    this.setState({
      loading: true,
    });
    getCountEserciziCommerciali(gruppoId, consulenteId)
      .then((countResponse) => {
        return getEserciziCommerciali(
          gruppoId,
          consulenteId,
          null,
          null,
          0,
          this.state.pageSize,
          'id',
        ).then((result) => {
          this.setState({
            loadedPage: 0,
            esercizi: result,
            totalPages:
              countResponse !== 0
                ? Math.ceil(countResponse / this.state.pageSize)
                : 1,
          });
        });
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() =>
        this.setState({
          loading: false,
        }),
      );
  };

  shouldStatoAbbonamentoShowUp = () => {
    const isAdmin = this.props.consulenteId === null;
    if (isAdmin) {
      return true;
    } else {
      let gruppoId = this.props.gruppoId;
      return true;
    }
  };

  fetchEserciziCommercialiForResearch = (loadedPage) => {
    const { filter, pageSize } = this.state;
    const isAdmin = this.props.consulenteId === null;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;

    const consulenteId = isConsulente
      ? this.props.consulenteId
      : filter.consulenteId;

    let gruppoId = isAdmin
      ? this.state.gruppoId !== -1
        ? this.state.gruppoId
        : filter.gruppoId
      : this.props.gruppoId;

    getCountEserciziCommerciali(
      gruppoId,
      consulenteId,
      null,
      filter.nome,
      filter.esercizioId,
      filter.ragioneSociale,
      filter.partitaIva,
      null,
      filter.cittaSede,
    )
      .then((countResponse) => {
        return getEserciziCommercialiFiltered(
          gruppoId,
          consulenteId,
          null,
          loadedPage,
          pageSize,
          'id',
          null,
          filter.nome,
          filter.esercizioId,
          filter.ragioneSociale,
          filter.partitaIva,
          null,
          filter.cittaSede,
        ).then((response) =>
          this.setState({
            loadedPage: 0,
            esercizi: response,
            totalPages:
              countResponse !== 0 ? Math.ceil(countResponse / pageSize) : 1,
          }),
        );
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  fetchEserciziCommercialiForPageChange = (loadedPage) => {
    const { filter, pageSize } = this.state;
    const isAdmin = this.props.consulenteId === null;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;
    const gruppoId = isAdmin ? filter.gruppoId : this.props.gruppoId;
    const consulenteId = isConsulente
      ? this.props.consulenteId
      : filter.consulenteId;

    const effectiveGruppoId =
      this.state.gruppoId !== null && this.state.gruppoId !== -1
        ? this.state.gruppoId
        : gruppoId;

    getEserciziCommercialiFiltered(
      effectiveGruppoId,
      consulenteId,
      null,
      loadedPage,
      pageSize,
      'id',
      null,
      filter.nome,
      filter.esercizioId,
      filter.ragioneSociale,
      filter.partitaIva,
      null,
      filter.cittaSede,
    )
      .then((response) => this.setState({ esercizi: response }))
      .catch((error) => {
        reportApiError(error);
      });
  };

  onPageChange = (pageIndex) => {
    this.setState({ loadedPage: pageIndex }, () =>
      this.fetchEserciziCommercialiForPageChange(this.state.loadedPage),
    );
  };

  compareDates = (b, a) => {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  };

  handleSelectedGruppo = (gruppoId) => {
    this.setState(
      {
        gruppoId,

        filter: {
          esercizioId: '',
          gruppoId: '',
          consulenteId: '',
          ragioneSociale: '',
          partitaIva: '',
          nome: '',
          cittaSede: '',
        },
      },
      () => this.fetchEserciziCommerciali(gruppoId),
    );
  };

  generateFilterColumn = ({ id, placeholder, filterValue, onChange }) => {
    return {
      Header: placeholder,
      id: id,
      accessor: (d) => d[id],
      filterable: true,
      minWidth: 120,
      Filter: (
        <TextField
          variant="outlined"
          fullWidth
          value={filterValue}
          onChange={(e) => {
            const value = e.target.value;
            onChange(value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => this.fetchEserciziCommercialiForResearch(0)}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ),
    };
  };

  getCommonColumns = () => {
    return [
      {
        Header: 'Numero',
        id: 'numero',
        accessor: (row) => row,
        minWidth: 90,
        filterable: false,
        Cell: (props) =>
          this.state.loadedPage === 0
            ? '' + props.index
            : this.state.loadedPage + '' + props.index,
      },
      this.generateFilterColumn({
        id: 'id',
        placeholder: 'ID esercizio',
        filterValue: this.state.filter.esercizioId,
        onChange: (value) => {
          if (/^\d*$/.test(value)) {
            this.setState((prevState) => ({
              filter: {
                ...prevState.filter,
                esercizioId: value,
              },
            }));
          }
        },
      }),
      {
        Header: 'Responsabili',
        id: 'responsabili',
        accessor: (row) => row,
        sortable: false,
        resizable: false,
        filterable: false,
        width: 120,
        Cell: (props) => (
          <Button
            type="button"
            onClick={(e) => {
              this.onVediButtonClicked(props.value, e);
            }}
            variant="contained"
            size="small"
            disabled={false}
            style={{
              color: this.props.theme.palette.text.main,
              padding: '0px',
              margin: '0px',
              backgroundColor: this.props.theme.palette.primary.main,
            }}
          >
            {'Vedi'}
          </Button>
        ),
      },
      this.generateFilterColumn({
        id: 'ragioneSociale',
        placeholder: 'Ragione sociale',
        filterValue: this.state.filter.ragioneSociale,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              ragioneSociale: value,
            },
          })),
      }),
      this.generateFilterColumn({
        id: 'nome',
        placeholder: 'Nome',
        filterValue: this.state.filter.nome,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              nome: value,
            },
          })),
      }),
      this.generateFilterColumn({
        id: 'partitaIva',
        placeholder: 'Partita IVA',
        filterValue: this.state.filter.partitaIva,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              partitaIva: value,
            },
          })),
      }),
      this.generateFilterColumn({
        id: 'cittaSede',
        placeholder: 'Sede',
        filterValue: this.state.filter.cittaSede,
        onChange: (value) =>
          this.setState((prevState) => ({
            filter: {
              ...prevState.filter,
              cittaSede: value,
            },
          })),
      }),
      {
        id: 'gestioneOperativaSeparata',
        Header: 'Gestione separata',
        accessor: (row) => row,
        filterable: false,
        width: 150,
        Cell: (props) =>
          props.value.gestioneOperativaSeparata ? (
            // <span>Sì</span>
            <Check style={{ color: '#7d7d7d' }} />
          ) : (
            // <span>No</span>
            <Remove fontSize="small" style={{ color: '#bfbfbf' }} />
          ),
      },
      {
        id: 'dataFineAbbonamento',
        Header: 'Stato Abbonamento',
        show: this.shouldStatoAbbonamentoShowUp() ? true : false,
        accessor: (row) => row.dataFineAbbonamento,
        sortable: false,
        filterable: false,
        Cell: (props) => {
          const dataFine = props.row.dataFineAbbonamento;
          if (dataFine === null) {
            return (
              <Tooltip title="Abbonamento inattivo o non esistente">
                <Lens style={{ color: '#aaaaaa' }} />
              </Tooltip>
            );
          }
          if (props.original.isSospeso === false) {
            return (
              <Tooltip title="Abbonamento attivo">
                <Lens style={{ color: '#2ecc40' }} />
              </Tooltip>
            );
          }
          const msPerDay = 1000 * 60 * 60 * 24;
          const now = new Date();
          const end = new Date(dataFine);
          const daysLeft = Math.floor(
            (Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()) -
              Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) /
              msPerDay,
          );
          if (daysLeft > 30) {
            return (
              <Tooltip title="Abbonamento attivo">
                <Lens style={{ color: '#2ecc40' }} />
              </Tooltip>
            );
          }
          if (daysLeft >= 10) {
            return (
              <Tooltip title="Abbonamento in scadenza tra meno di 30 giorni">
                <Lens style={{ color: '#ffc339' }} />
              </Tooltip>
            );
          }
          if (daysLeft > 0) {
            return (
              <Tooltip title="Abbonamento in scadenza tra meno di 10 giorni">
                <Lens style={{ color: '#FD6A02' }} />
              </Tooltip>
            );
          }
          return (
            <Tooltip title="Abbonamento scaduto">
              <Lens style={{ color: '#ff0000' }}></Lens>
            </Tooltip>
          );
        },
      },
      {
        id: 'editBtn',
        Header: 'Modifica',
        accessor: (row) => row,
        sortable: false,
        filterable: false,
        width: 80,
        Cell: (props) => (
          <EditRecordButton recordId={props.value.id} disabled={false} />
        ),
      },
    ];
  };

  getColumns = () => {
    let columns = this.getCommonColumns();
    const isAdmin =
      this.props.consulenteId === null && !this.props.superconsulenteView;
    const isSuperConsulente = this.props.superconsulenteView;

    if (isAdmin) {
      columns.splice(
        2,
        0,
        /*this.generateFilterColumn({
          id: "gruppoId",
          placeholder: "ID gruppo",
          filterValue: this.state.filter.gruppoId,
          onChange: (value) => {
            if (/^\d*$/.test(value)) {
              this.setState((prevState) => ({
                filter: {
                  ...prevState.filter,
                  gruppoId: value,
                },
              }));
            }
          },
        }),*/
        {
          id: 'gruppoId',
          Header: 'ID gruppo',
          accessor: (row) => row.gruppoId,
          filterable: false,
        },
        this.generateFilterColumn({
          id: 'consulenteId',
          placeholder: 'ID consulente',
          filterValue: this.state.filter.consulenteId,
          onChange: (value) => {
            if (/^\d*$/.test(value)) {
              this.setState((prevState) => ({
                filter: {
                  ...prevState.filter,
                  consulenteId: value,
                },
              }));
            }
          },
        }),
      );
    } else if (isSuperConsulente) {
      columns.splice(
        2,
        0,
        this.generateFilterColumn({
          id: 'consulenteId',
          placeholder: 'ID consulente',
          filterValue: this.state.filter.consulenteId,
          onChange: (value) => {
            if (/^\d*$/.test(value)) {
              this.setState((prevState) => ({
                filter: {
                  ...prevState.filter,
                  consulenteId: value,
                },
              }));
            }
          },
        }),
      );
    }

    return columns;
  };

  onVediButtonClicked = (esercizio, event) => {
    let nomeEsercizio = '';
    if (esercizio.nome !== null) {
      nomeEsercizio = esercizio.nome;
    }
    this.setState({
      selectedEsercizioName: nomeEsercizio,
      isModalResponsabiliOpen: true,
      loadingModalResponsabili: true,
    });

    getResponsabiliSicurezzaEsercizio(esercizio.id)
      .then((result) => {
        this.setState({
          selectedEsercizioName: nomeEsercizio,
          responsabiliEsercizio: result,
          loadingModalResponsabili: false,
          errorModalResponsabili: '',
        });
      })
      .catch((error) => {
        this.setState({
          loadingModalResponsabili: false,
          errorModalResponsabili: error.message,
        });
      });
  };

  closeModalResponsabili = () => {
    this.setState({
      isModalResponsabiliOpen: false,
    });
  };

  render() {
    const isAdmin =
      this.props.consulenteId === null && !this.props.superconsulenteView;
    const columns = this.getColumns();

    return (
      <div
        style={{ paddingTop: isAdmin ? '10px' : '30px', minHeight: '400px' }}
      >
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <div style={styles.mainContainer}>
            {isAdmin && (
              <TablePageToolbar
                filters={
                  <SelezioneGruppo
                    layout="toolbar"
                    gruppoId={this.state.gruppoId}
                    gruppi={this.state.gruppi}
                    disabled={false}
                    description=""
                    onGruppoSelected={this.handleSelectedGruppo}
                  />
                }
              />
            )}
            <div style={styles.newRecordButtonWrapper}>
              <NewRecordButton disabled={false} />
            </div>
            <BasicTable
              data={this.state.esercizi}
              columns={columns}
              resizable={true}
              sortable={false}
              defaultPageSize={this.state.pageSize}
              page={this.state.loadedPage}
              pages={this.state.totalPages}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
        {this.state.isModalResponsabiliOpen && (
          <ModalResponsabiliEsercizio
            open={this.state.isModalResponsabiliOpen}
            loading={this.state.loadingModalResponsabili}
            onCloseModal={this.closeModalResponsabili}
            nomeEsercizio={this.state.selectedEsercizioName}
            responsabili={this.state.responsabiliEsercizio}
            errorLabel={this.state.errorModalResponsabili}
          />
        )}
      </div>
    );
  }
}

EserciziCommercialiTable.propTypes = {
  consulenteId: PropTypes.number,
  gruppoId: PropTypes.number,
  superconsulenteView: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
};
